export default "__VITE_ASSET__DxB1DoPl__"